import React from 'react';
import { Trans } from '@lingui/macro';

export default {
  title: (
    <Trans id="general.includedInPack.title" defaults="Each pack includes" />
  ),
  bonus1: (
    <Trans
      id="general.includedInPack.bonus1"
      defaults="Cancel any time and pro-rata reimbursment"
    />
  ),
  bonus2: (
    <Trans id="general.includedInPack.bonus2" defaults="Secured SSL payment" />
  ),
  bonus3: (
    <Trans id="general.includedInPack.bonus3" defaults="Assistance 24/7" />
  ),
};
